import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdminLogRange, IAdminLogCatalogItem, IAdminLogPage } from './admin-log.interface';

/**
 * Thin client for the generic /cron-log API surface. Two endpoints,
 * both AdminAuth-gated server-side:
 *
 *   GET /cron-log           → catalog + per-log fs metadata
 *   GET /cron-log/{name}    → paginated tail of one log
 *
 * Mirrors the shape of MassService.log() so the existing log-viewer
 * affordances (mass-log component) work unchanged for any catalog
 * entry — see AdminLogComponent for the consumer.
 */
@Injectable()
export class AdminLogService {
  constructor(private http: HttpClient) {}

  catalog(): Observable<IAdminLogCatalogItem[]> {
    return this.http.get<IAdminLogCatalogItem[]>(
      `${environment.apiEndpoint}/cron-log`
    );
  }

  read(
    name: string,
    params?: { page?: number; per_page?: number; range?: AdminLogRange }
  ): Observable<IAdminLogPage> {
    let httpParams = new HttpParams();
    if (params?.page) httpParams = httpParams.set('page', String(params.page));
    if (params?.per_page) httpParams = httpParams.set('per_page', String(params.per_page));
    if (params?.range) httpParams = httpParams.set('range', params.range);
    return this.http.get<IAdminLogPage>(
      `${environment.apiEndpoint}/cron-log/${encodeURIComponent(name)}`,
      { params: httpParams }
    );
  }
}
